
import { Component, Prop, Vue } from 'vue-property-decorator';
import { InjectionRate } from '@/interfaces/models/InjectionRate';
import { Venue } from '@/interfaces/models/Venue';

@Component
export default class InjectionRateTable extends Vue {
  @Prop({ type: Array, default: () => [] }) public items!: InjectionRate[];
  @Prop({ type: Array, default: () => [] }) public venues!: Venue[];
  @Prop({ type: Boolean, default: false }) public loading!: boolean;

  get headers() {
    return [
      { text: this.$t('injectionRates.table.provider'), value: 'externalOrderProvider' },
      { text: this.$t('injectionRates.table.venue'), value: 'venue' },
      { text: this.$t('injectionRates.table.received'), value: 'receivedCount' },
      { text: this.$t('injectionRates.table.injected'), value: 'injectedCount' },
      { text: this.$t('injectionRates.table.failed'), value: 'failedCount' },
      { text: this.$t('injectionRates.table.rate'), value: 'injectionRate' },
    ];
  }

  get venueNameById(): Record<string, string> {
    return this.venues.reduce((acc: Record<string, string>, venue: Venue) => {
      acc[venue._id] = venue.name;
      return acc;
    }, {});
  }

  get totals(): { receivedCount: number; injectedCount: number; failedCount: number; injectionRate: number } {
    const receivedCount = this.items.reduce((sum, i) => sum + i.receivedCount, 0);
    const injectedCount = this.items.reduce((sum, i) => sum + i.injectedCount, 0);
    const failedCount = this.items.reduce((sum, i) => sum + i.failedCount, 0);
    const injectionRate = receivedCount > 0 ? (injectedCount / receivedCount) * 100 : 0;

    return { receivedCount, injectedCount, failedCount, injectionRate };
  }

  public abs(value: number): number {
    return Math.abs(value);
  }

  public venueName(id: string): string {
    return this.venueNameById[id] || id;
  }

  public providerLabel(provider: string): string {
    const key = `injectionRates.providers.${provider}`;
    const translated = this.$t(key) as string;
    return translated === key ? provider : translated;
  }

  public rateClass(rate: number): string {
    if (rate >= 95) {
      return 'success--text';
    }
    if (rate >= 85) {
      return 'warning--text';
    }
    return 'error--text';
  }
}
